import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import KPSelectableList from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableList'
import { ISelectableListItem } from '../../../../interfaces/KPSelectableList/KPSelectableListInterfaces';
import './PropertyBorders.css';
import { postToController } from '../../../../actions/apiActions';
import { BUILDING_BORDER_FIELD_ID, BUILDING_BORDER_INFORMAL_ID, BUILDING_BORDER_PLOT_ID, BUILDING_BORDER_RIVER_ID } from '../../../../constants/constants';

class PropertyBorders extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            items: [],
            propertyBorders: this.props.sales.propertyBorders ?? { field: false, river: false, informalSettlement: false, farmPlot: false },
            submitted: false,
            nextDisabled: false
        };

        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.getListDataSet = this.getListDataSet.bind(this);
    }

    async getListDataSet() {
        let dataSet: ISelectableListItem[] = [];
        await postToController(this.props.dispatch, 'GetPropertyBorders', JSON.stringify({})).then(async (response) => {
            response.forEach((item, index) => {
                switch (item.id) {
                    case BUILDING_BORDER_FIELD_ID:
                        dataSet.push({
                            id: "chkField",
                            value: item.id,
                            label: item.description,
                            selected: this.props.sales.propertyBorders?.field ?? false,
                            required: false,
                            disabled: false,
                            handleSelect: null,
                            selectOnLeft: false,
                            className: ""
                        } as ISelectableListItem);
                        break;
                    case BUILDING_BORDER_RIVER_ID:
                        dataSet.push({
                            id: "chkRiver",
                            value: item.id,
                            label: item.description,
                            selected: this.props.sales.propertyBorders?.river ?? false,
                            required: false,
                            disabled: false,
                            handleSelect: null,
                            selectOnLeft: false,
                            className: ""
                        } as ISelectableListItem);
                        break;
                    case BUILDING_BORDER_INFORMAL_ID:
                        dataSet.push({
                            id: "chkInformalSettlement",
                            value: item.id,
                            label: item.description,
                            selected: this.props.sales.propertyBorders?.informalSettlement ?? false,
                            required: false,
                            disabled: false,
                            handleSelect: null,
                            selectOnLeft: false,
                            className: ""
                        } as ISelectableListItem);
                        break;
                    case BUILDING_BORDER_PLOT_ID:
                        dataSet.push({
                            id: "chkFarmPlot",
                            value: item.id,
                            label: item.description,
                            selected: this.props.sales.propertyBorders?.farmPlot ?? false,
                            required: false,
                            disabled: false,
                            handleSelect: null,
                            selectOnLeft: false,
                            className: ""
                        } as ISelectableListItem);
                        break;
                    default:
                        break;
                }
            });
        });
       
        this.setState({ items: dataSet });
    }

    handleItemSelect(id: string, selected: boolean) {
        let name = id.slice(3);
        name = name.charAt(0).toLowerCase() + name.slice(1);
        this.setState({ propertyBorders: { ...this.state.propertyBorders, [name]: selected } });
    }

    async handleNextStep() {
        this.props.dispatchAction(setQuoteData({ propertyBorders: this.state.propertyBorders }));
        this.props.dispatchAction(handleNextStep());
    }

    componentWillMount() {
        this.getListDataSet()
    }

    public render() {
        return (
            <div className="container">
                <div className="mt-4 text-center">
                    <p>Does the property have the following borders?</p>
                </div>

                {this.state.items.length > 0 &&
                    <div className="row mt-4">
                        <div className="col-md-6 offset-md-3 text-left">
                            <KPSelectableList
                                items={this.state.items}
                                handleSelect={this.handleItemSelect}
                                autosize={true}
                            />
                        </div>
                    </div>
                }

                <div className="row mt-4">
                    <div className="col-12 justify-content-center">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyBorders);